import { Component } from '@angular/core';

@Component({
  selector: 'app-close-icon',
  standalone: true,
  templateUrl: './close-icon.component.html',
})
export class CloseIconComponent {}
